module.exports = __webpack_public_path__ + "img/logo.8cbca2d7.png";